var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSources(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 342 205",
    style: {
      enableBackground: "new 0 0 342 205"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9A9A9A;}\n\t.st1{fill:none;stroke:#404040;stroke-width:2;stroke-miterlimit:10;}\n\t.st2{fill:#8E8E8E;}\n\t.st3{fill:#404040;}\n\t.st4{fill:none;stroke:#404040;stroke-width:2.2424;stroke-miterlimit:10;}\n\t.st5{fill:#6E6E6E;}\n\t.st6{fill:#4E4E4E;}\n\t.st7{fill:#FFFFFF;}\n\t.st8{fill:#E7E7E7;}\n\t.st9{fill:#BBBBBB;}\n\t.st10{fill:#7C7C7C;}\n\t.st11{fill:#787878;}\n\t.st12{fill:#3C3C3C;}\n\t.st13{fill:#565656;}\n\t.st14{fill:#2C2C2C;}\n\t.st15{fill:#1D1D1D;}\n\t.st16{fill:#838383;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M341.5,177.2c0,10.2-2.9,19.8-8,27.8H12.3c-7.4-12.5-11.7-27.1-11.7-42.7c0-40.1,28.2-73.5,65.8-81.6 c-0.1-0.9-0.1-1.8-0.1-2.7c0-18.4,14.9-33.3,33.2-33.3c6.9,0,13.3,2.1,18.6,5.7c20.5-22.9,50.4-37.3,83.6-37.3 c62,0,112.3,50.3,112.3,112.4c0,1.9,0,3.7-0.1,5.6C330.3,139.9,341.5,157.3,341.5,177.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M231.2,120V86.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M230.2,93.1c2.3,0,3.6-0.5,4.6-0.8c0.8-0.3,1.5-0.6,2.9-0.6c1.4,0,2.1,0.2,2.9,0.6c1,0.4,2.3,0.8,4.6,0.8 s3.6-0.5,4.6-0.8c0.8-0.3,1.5-0.6,2.9-0.6s2.1,0.2,2.9,0.6c1,0.4,2.3,0.8,4.6,0.8s3.6-0.5,4.6-0.8c0.8-0.3,1.5-0.6,2.9-0.6l-1.2-2.4 l1.2-2.5c-2.3,0-3.6,0.5-4.6,0.8c-0.8,0.3-1.5,0.6-2.9,0.6s-2.1-0.2-2.9-0.6c-1-0.4-2.3-0.8-4.6-0.8s-3.6,0.5-4.6,0.8 c-0.8,0.3-1.5,0.6-2.9,0.6s-2.1-0.2-2.9-0.6c-1-0.4-2.3-0.8-4.6-0.8c-2.3,0-3.6,0.5-4.6,0.8c-0.8,0.3-1.5,0.6-2.9,0.6V93.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M231.2,120.9c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9s-0.9,0.4-0.9,0.9 C230.3,120.5,230.7,120.9,231.2,120.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M231.2,87.4c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6 C230.5,87.1,230.8,87.4,231.2,87.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M134.4,41.6V1.2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M134.4,1.9c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.7-0.7-0.7c-0.4,0-0.7,0.3-0.7,0.7C133.7,1.6,134,1.9,134.4,1.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M166.4,27.3c-0.6-0.2-1.1-0.3-1.8-0.3c-1.7,0-3.2,0.7-4.2,1.9c-1.1-1.2-2.5-1.9-4.2-1.9c-1.7,0-3.2,0.7-4.2,1.9 c-0.7-0.8-1.6-1.4-2.7-1.7c-0.5-0.1-1-0.2-1.5-0.2c-1.7,0-3.2,0.7-4.2,1.9c-1-1.2-2.5-1.9-4.2-1.9c-1.7,0-3.2,0.7-4.2,1.9 c-1.1-1.2-2.5-1.9-4.2-1.9c-1.7,0-3.2,0.7-4.2,1.9c-1-1.2-2.5-1.9-4.2-1.9c-1.1,0-2.1,0.3-3,0.9c-0.5,0.3-0.8,0.6-1.2,1 c-1-1.2-2.5-1.9-4.2-1.9s-3.2,0.7-4.2,1.9c-1.1-1.2-2.5-1.9-4.2-1.9c-1.2,0-2.3,0.4-3.2,1c0.6-14,14.7-25.2,31.8-25.2 C151.4,2.9,165.2,13.7,166.4,27.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M149.3,27.3c-0.5-0.1-1-0.2-1.5-0.2c-1.7,0-3.2,0.7-4.2,1.9c-1.1-1.2-2.5-1.9-4.2-1.9c-1.7,0-3.2,0.7-4.2,1.9 c-1.1-1.2-2.5-1.9-4.2-1.9s-3.2,0.7-4.2,1.9c-1.1-1.2-2.5-1.9-4.2-1.9c-1.1,0-2.1,0.3-3,0.9c1.1-14.2,7.4-25,14.9-25 C141.9,2.9,148.1,13.4,149.3,27.3z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M205.9,12.4c-12.6,0-23.1,8.4-26.4,19.9h52.8C229,20.8,218.4,12.4,205.9,12.4z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M277.9,12.4c-12.6,0-23.1,8.4-26.4,19.9h52.8C301.1,20.8,290.5,12.4,277.9,12.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M243.6,3.8c-17.9,0-33,12-37.7,28.5h75.5C276.6,15.9,261.5,3.8,243.6,3.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M211.6,27c-8,0-14.7,5.4-16.8,12.7h33.6C226.3,32.4,219.6,27,211.6,27z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M257.5,27c-8,0-14.7,5.4-16.8,12.7h33.6C272.2,32.4,265.4,27,257.5,27z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M235.6,21.5c-11.4,0-21,7.7-24,18.1h48.1C256.6,29.2,247,21.5,235.6,21.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M65.5,127.8c-10.9,0-20.1,7.3-23,17.3h45.9C85.6,135.1,76.5,127.8,65.5,127.8z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M128.2,127.8c-10.9,0-20.1,7.3-23,17.3h45.9C148.3,135.1,139,127.8,128.2,127.8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M98.3,120.4c-15.6,0-28.7,10.4-32.8,24.7h65.6C127,130.8,113.9,120.4,98.3,120.4z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M93.5,122.6c-0.7-0.2-1.3-0.5-2-0.7L93.5,122.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M263.8,182.6H68.2c-3.6,0-6.5-2.9-6.5-6.6s2.9-6.6,6.5-6.6h195.5c3.6,0,6.5,2.9,6.5,6.6 C270.3,179.7,267.4,182.6,263.8,182.6z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M22.9,141.3c-8.5,0-15.7,5.7-18,13.6h35.9C38.6,147,31.4,141.3,22.9,141.3z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M71.9,141.3c-8.5,0-15.8,5.7-18,13.6h35.9C87.7,147,80.5,141.3,71.9,141.3z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M48.5,135.5c-12.2,0-22.5,8.2-25.7,19.4h51.3C71,143.7,60.8,135.5,48.5,135.5z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M273.9,53.9c-6.5,0-12.1,4.4-13.8,10.4h27.6C286,58.3,280.5,53.9,273.9,53.9z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M311.6,53.9c-6.5,0-12.1,4.4-13.8,10.4h27.6C323.7,58.3,318.1,53.9,311.6,53.9z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M293.6,49.5c-9.4,0-17.3,6.3-19.7,14.9h39.4C310.9,55.7,303,49.5,293.6,49.5z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M238.9,71.7c-4.3,0-7.9,2.9-9,6.8h18C246.7,74.5,243.1,71.7,238.9,71.7z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M263.4,71.7c-4.3,0-7.9,2.9-9,6.8h18C271.2,74.5,267.6,71.7,263.4,71.7z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M251.7,68.8c-6.1,0-11.2,4.1-12.8,9.7h25.7C262.9,72.9,257.8,68.8,251.7,68.8z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M220.1,156.5c-9.7,0-17.8,6.5-20.4,15.4h40.7C237.9,163,229.7,156.5,220.1,156.5z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M275.7,156.5c-9.7,0-17.9,6.5-20.4,15.4H296C293.5,163,285.3,156.5,275.7,156.5z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M249.2,149.9c-13.8,0-25.5,9.3-29.1,22h58.2C274.6,159.2,263,149.9,249.2,149.9z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M279.5,100.6c-0.2,0.1-0.5,0.2-0.7,0.4c-0.2-0.1-0.4-0.2-0.7-0.4c-0.9-0.5-2.1-0.7-3.3-0.7c-2,0-3.9,0.8-5,2 c0.5-2.3,2.5-4.1,5-4.1c1.6,0,3,0.7,3.9,1.9C279,99.9,279.3,100.3,279.5,100.6z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M287.7,101.9c-1.2-1.2-3-2-5-2c-1.2,0-2.3,0.3-3.3,0.7c-0.2,0.1-0.5,0.2-0.7,0.4c-0.2-0.1-0.4-0.2-0.7-0.4 c0.2-0.4,0.4-0.7,0.7-1.1c0.9-1.1,2.3-1.9,3.9-1.9C285.2,97.7,287.3,99.5,287.7,101.9z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M290.9,86.8c-0.2,0.2-0.3,0.4-0.5,0.6c-0.2,0-0.5-0.1-0.8-0.1c-1,0-2.2,0.2-3.3,0.7c-1.9,0.8-3.2,2.2-3.8,3.8 c-0.5-2.3,0.6-4.8,2.9-5.8c1.4-0.6,3-0.6,4.3,0.1C290.2,86.3,290.6,86.6,290.9,86.8z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M299,84.6c-1.5-0.6-3.5-0.6-5.4,0.2c-1.1,0.5-2,1.2-2.7,2c-0.2,0.2-0.3,0.4-0.5,0.6c-0.2,0-0.5-0.1-0.8-0.1 c0-0.4,0.1-0.8,0.2-1.2c0.4-1.4,1.4-2.6,2.8-3.3C295,81.9,297.6,82.6,299,84.6z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M334.1,85.9c-0.2,0-0.5,0.1-0.7,0.1c-0.1-0.2-0.3-0.4-0.5-0.6c-0.8-0.7-1.7-1.4-2.9-1.8 c-1.9-0.7-3.9-0.5-5.4,0.2c1.2-2.1,3.7-3.1,6.1-2.3c1.5,0.5,2.6,1.6,3.1,3C334,85.1,334.1,85.5,334.1,85.9z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M341.6,89.7c-0.7-1.5-2.2-2.8-4.1-3.5c-1.1-0.4-2.3-0.5-3.3-0.4c-0.2,0-0.5,0.1-0.7,0.1 c-0.1-0.2-0.3-0.4-0.5-0.6c0.3-0.3,0.6-0.6,1-0.8c1.3-0.8,2.8-1,4.3-0.5C340.5,85,341.9,87.4,341.6,89.7z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M66.6,98.3v29.5c-0.3,0-0.7,0-1,0s-0.7,0-1,0V98.3H66.6z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.4,92.1l0.5,3.5c1.3-0.5,2.7-0.8,4.1-1.1l0.6-4.4l0.5,4.2c1.3-0.2,2.7-0.3,4-0.4l0.5-3.9l0.5,3.8 c6.5,0.1,12.4,2.2,16.6,5.5c-1.2-8.3-8.3-14.6-16.9-14.6s-15.7,6.4-16.9,14.6c1.7-1.4,3.8-2.6,6-3.5L38.4,92.1z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M92.7,92.1l-0.5,3.5c-1.3-0.5-2.7-0.8-4.1-1.1l-0.6-4.4l-0.5,4.2c-1.3-0.2-2.7-0.3-4-0.4l-0.5-3.9l-0.5,3.8 c-6.5,0.1-12.4,2.2-16.6,5.5c1.2-8.3,8.3-14.6,16.9-14.6s15.7,6.4,16.9,14.6c-1.7-1.4-3.8-2.6-6-3.5L92.7,92.1z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M83.9,78.1l1.6,3.2c-1.3,0.4-2.7,0.8-4,1.4l-2.9-3.3l1.9,3.8c-1.2,0.6-2.4,1.2-3.5,2l-2.6-2.9l1.8,3.4 c-5.4,3.7-9.1,8.8-10.6,13.9c-3.7-7.5-1.4-16.8,5.7-21.6c7.1-4.8,16.6-3.6,22.2,2.6c-2.2-0.2-4.6,0-6.9,0.5L83.9,78.1z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47.2,78.1l-1.6,3.2c1.3,0.4,2.7,0.8,4,1.4l2.9-3.3l-1.9,3.8c1.2,0.6,2.4,1.2,3.5,2l2.6-2.9l-1.8,3.4 c5.4,3.7,9.1,8.8,10.6,13.9c3.7-7.5,1.4-16.8-5.7-21.6s-16.6-3.6-22.2,2.6c2.2-0.2,4.5,0,6.9,0.5L47.2,78.1z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M238,61.8h-99.1v110H238V61.8z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M227.6,40h-88.7v21.9H238V50.4L227.6,40z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M226.4,69.1h-76.1v3.7h76.1V69.1z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M226.4,76.6h-76.1v1.9h76.1V76.6z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M191.3,80.1h-40.9v1.9h40.9V80.1z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M208.5,83.5h-58.2v1.9h58.2V83.5z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M218.3,87h-67.9v1.9h67.9V87z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M218.3,90.5h-67.9v1.9h67.9V90.5z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M167.1,104.8h-16.8v1.9h16.8V104.8z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M167.1,108.2h-16.8v1.9h16.8V108.2z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M167.1,111.7h-16.8v1.9h16.8V111.7z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M167.1,115.2h-16.8v1.9h16.8V115.2z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M167.1,118.7h-16.8v1.9h16.8V118.7z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M186.2,104.8h-16.8v1.9h16.8V104.8z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M186.2,108.2h-16.8v1.9h16.8V108.2z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M186.2,111.7h-16.8v1.9h16.8V111.7z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M186.2,115.2h-16.8v1.9h16.8V115.2z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M186.2,118.7h-16.8v1.9h16.8V118.7z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M226.4,104.8h-38v1.9h38V104.8z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M226.4,108.2h-38v1.9h38V108.2z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M226.4,111.7h-38v1.9h38V111.7z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M226.4,115.2h-38v1.9h38V115.2z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M226.4,118.7h-38v1.9h38V118.7z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M226.4,133.3h-76.1v1.9h76.1V133.3z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M214.9,136.8h-64.5v1.9h64.5V136.8z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M214.9,140.3h-64.5v1.9h64.5V140.3z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M182,147.2h-31.6v1.9H182V147.2z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M182,150.7h-31.6v1.9H182V150.7z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M226.4,97.6h-76.1v3.7h76.1V97.6z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M226.4,126.1h-76.1v3.7h76.1V126.1z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M176.5,49.7h-24.6v4.2h24.6V49.7z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M224.9,49.7h-44.2v4.2h44.2V49.7z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M218.7,144.1c-4.9,0-8.9,4-8.9,8.9c0,4.9,4,8.9,8.9,8.9c4.9,0,8.9-4,8.9-8.9 C227.6,148.1,223.6,144.1,218.7,144.1z M218.7,160.5c-4.1,0-7.4-3.3-7.4-7.4c0-4.1,3.3-7.4,7.4-7.4c4.1,0,7.4,3.3,7.4,7.4 C226.1,157.2,222.8,160.5,218.7,160.5z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M215.2,149.6c-1.9,1.9-1.9,5,0,6.9l6.9-6.9C220.3,147.7,217.2,147.7,215.2,149.6z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M222.1,149.6l-6.9,6.9c1.9,1.9,5,1.9,6.9,0S224,151.5,222.1,149.6z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M227.6,50.4H238L227.6,40V50.4z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M110.3,122.6V71.7h-2v50.2L110.3,122.6z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82.1,65.5l0.5,3.5c1.3-0.5,2.7-0.8,4.1-1.1l0.6-4.4l0.5,4.2c1.3-0.2,2.7-0.3,4-0.4l0.5-3.9l0.5,3.8 c6.5,0.1,12.4,2.2,16.6,5.5c-1.2-8.3-8.3-14.6-16.9-14.6c-8.6,0-15.7,6.4-16.9,14.6c1.7-1.4,3.8-2.6,6-3.5L82.1,65.5z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M136.5,65.5l-0.5,3.5c-1.3-0.5-2.7-0.8-4.1-1.1l-0.6-4.4l-0.5,4.2c-1.3-0.2-2.7-0.3-4-0.4l-0.5-3.9l-0.5,3.8 c-6.5,0.1-12.4,2.2-16.6,5.5c1.2-8.3,8.3-14.6,16.9-14.6s15.7,6.4,16.9,14.6c-1.7-1.4-3.8-2.6-6-3.5L136.5,65.5z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M127.6,51.5l1.6,3.2c-1.3,0.4-2.7,0.8-4,1.4l-2.9-3.3l1.9,3.8c-1.2,0.6-2.4,1.2-3.5,2l-2.6-2.9l1.8,3.4 c-5.4,3.7-9.1,8.8-10.6,13.9c-3.7-7.5-1.4-16.8,5.7-21.6c7.1-4.8,16.6-3.6,22.2,2.6c-2.2-0.2-4.6,0-6.9,0.5L127.6,51.5z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91,51.5l-1.6,3.2c1.3,0.4,2.7,0.8,4,1.4l2.9-3.3l-1.9,3.8c1.2,0.6,2.4,1.2,3.5,2l2.6-2.9L98.7,59 c5.4,3.7,9.1,8.8,10.6,13.9c3.7-7.5,1.4-16.8-5.7-21.6c-7.1-4.8-16.6-3.6-22.2,2.6c2.2-0.2,4.6,0,6.9,0.5L91,51.5z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M97.9,174.5c0,0-0.1,0-0.1-0.1c-0.3-0.2-0.5-0.6-0.2-1l2.6-4.4c0.2-0.4,0.6-0.5,1-0.2c0.3,0.2,0.5,0.6,0.2,1 l-2.6,4.4C98.6,174.5,98.2,174.6,97.9,174.5z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M97.7,172.9c0,0-1.6,1-1.3,1.4c0.3,0.3,4.8,4.8,5,4.7c0.8-0.6-2.3-4.9-2.8-5.1 C98.2,173.5,97.9,172.7,97.7,172.9z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M132.3,135.8c0,0,3.1,2,3.2,2.9c0.1,0.9-3-0.6-4.1-2.6L132.3,135.8z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M132.7,135.5c-0.3,0.5-0.6,1-0.9,1.5c-7.8-5.3-10.6-8.4-9.2-18c0.2-1.5,0.8-1.5,1.9-1.1c0.1-0.2,0.1-0.2,0,0 c1,0.4,1.1,0.9,0.9,2.1C124,128.5,126.5,130.3,132.7,135.5z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M124.3,177.4c0,0-0.1,0-0.1,0.1c-0.4,0.1-0.8-0.1-0.9-0.5l-1.4-4.9c-0.1-0.4,0.1-0.8,0.5-0.9 c0.4-0.1,0.8,0.1,0.9,0.5l1.4,4.9C124.8,176.9,124.6,177.2,124.3,177.4z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M124.5,173.9c-0.7,0.4-1.3,0.8-2,1.2c-4.3-12.7-6.2-29.2-11.1-40.5c1.9-0.7,3.8-1.4,5.7-2.2 C121.6,145.8,118.1,158.4,124.5,173.9z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M100.1,172.6c-0.7-0.4-1.4-0.7-2-1.1c7.9-13.6,12.9-22.8,12-39.1c2-0.3,4.1-0.5,6.1-0.7 C116.1,147.2,108.2,160,100.1,172.6z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M129.6,109.8c-0.6-0.3-1.6-0.3-2.1,0.2c-0.5,0.5-0.4,1.4,0.1,1.9c0.5,0.5,2,0.5,2.5,0 C130.6,111.4,130.3,110.3,129.6,109.8z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M125.3,112.9c-0.7-1.5-2.6-2.6-4.3-2.3c-1.7,0.3-2.5,2.2-2.2,3.7c0.3,1.6,2.5,3.6,5,3.3 C125.5,117.5,126.1,114.8,125.3,112.9z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M126.7,112.3c-0.5-1.1-1.9-2-3-1.8c-1.2,0.2-1.8,1.6-1.6,2.8c0.2,1.2,2.3,2.6,3.5,2.4 C126.7,115.6,127.3,113.7,126.7,112.3z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M124.7,112.8c0,2.2,1.4,3.9,2.8,4c1.3,0,2-1.7,2-3.9c0-2.2-1-3.3-2.3-3.3C125.9,109.6,124.8,110.7,124.7,112.8z "
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M123.8,113.6c0,0.5,0.5,1.2,0.8,1.2s0.5-0.4,0.5-0.9c0-0.5-0.3-1-0.6-1S123.8,113.1,123.8,113.6z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M124.5,111.5c0,0,0.5-1.4,1.6-1.9c1.1-0.5,3.1-0.3,3.6,1.5c0,0,0.2,1.4-1.5,1.5c-1.7,0.1-1.3-0.8-2.2,0 c-0.9,0.8-1.6,0.1-1.8,0.2L124.5,111.5z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M115.9,138.5c-1.5-0.7-2.5-1.8-3.4-3.2c-0.7-1.1-1.9-2-2.7-2.9c1.5-5.1,6.4-12.3,9.7-14.5 c2.9-1.9,2.7-1.4,3.4-1.4c1,0.1,1.9,0.6,2.2,1.5c0,0,0,0,0,0.1c0.4,1.1-0.4,2.7-1,4.4c-0.7,1.7,0.1,1.7-2.7,3.9 C120.2,127.2,117.2,136.1,115.9,138.5z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M125.2,113.4l1.9,1.2c-0.2,0.3-1.7,2.8-2.5,3.6c-0.3,0.2-0.8,0-1.2-0.5c-0.3-0.4-0.5-0.9-0.3-1.2 C123.6,116,124.7,114.3,125.2,113.4z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M123,176.6c0,0-0.5,1.8,0,1.9c0.5,0,6.8,0.2,6.8,0c0.1-1-5.1-1.9-5.6-1.8C123.8,176.7,123.1,176.3,123,176.6z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M127.9,137.4c0,0,3.7,0.9,4.1,1.8c0.4,0.9-3.3,0.4-4.9-1.2L127.9,137.4z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M128.8,137.5c-0.2,0.6-0.4,1.1-0.6,1.7c-10.9-5.4-11.4-8.9-9.2-20.3c0.3-1.8,3.4-1.2,2.5,1.6 C118.5,130.5,119.9,131.7,128.8,137.5z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M24.7,115.9c1.6-0.2,2.9-1.5,3.1-3.1c0,0,0.1,0,0.1,0c0.2,1.6,1.5,2.9,3.1,3.1c0,0,0,0.1,0,0.1 c-1.6,0.2-2.9,1.5-3.1,3.1c0,0-0.1,0-0.1,0C27.6,117.5,26.3,116.2,24.7,115.9C24.7,115.9,24.7,115.9,24.7,115.9z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M231.7,65.5c1.6-0.2,2.9-1.5,3.1-3.1c0,0,0.1,0,0.1,0c0.2,1.6,1.5,2.9,3.1,3.1c0,0,0,0.1,0,0.1 c-1.6,0.2-2.9,1.5-3.1,3.1c0,0-0.1,0-0.1,0C234.6,67.1,233.3,65.8,231.7,65.5C231.7,65.6,231.7,65.5,231.7,65.5z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M20.1,124.1c1.1-0.2,1.9-1.1,2.1-2.1c0,0,0.1,0,0.1,0c0.2,1.1,1,1.9,2.1,2.1c0,0,0,0.1,0,0.1 c-1.1,0.2-1.9,1.1-2.1,2.1c0,0-0.1,0-0.1,0C22,125.2,21.1,124.4,20.1,124.1C20,124.2,20,124.2,20.1,124.1z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M197.5,35.9c1.1-0.2,1.9-1.1,2.1-2.1c0,0,0.1,0,0.1,0c0.2,1.1,1.1,1.9,2.1,2.1c0,0,0,0.1,0,0.1 c-1.1,0.2-1.9,1.1-2.1,2.1c0,0-0.1,0-0.1,0C199.5,37,198.6,36.1,197.5,35.9C197.5,36,197.5,35.9,197.5,35.9z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M140.7,144.1c1.1-0.2,1.9-1.1,2.1-2.1c0,0,0.1,0,0.1,0c0.2,1.1,1.1,1.9,2.1,2.1c0,0,0,0.1,0,0.1 c-1.1,0.2-1.9,1.1-2.1,2.1c0,0-0.1,0-0.1,0C142.6,145.2,141.7,144.3,140.7,144.1C140.6,144.1,140.6,144.1,140.7,144.1z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M113,14.8c1.1-0.2,1.9-1.1,2.1-2.1c0,0,0.1,0,0.1,0c0.2,1.1,1.1,1.9,2.1,2.1c0,0,0,0.1,0,0.1 c-1.1,0.2-1.9,1.1-2.1,2.1c0,0-0.1,0-0.1,0C114.9,15.9,114,15.1,113,14.8C112.9,14.9,112.9,14.8,113,14.8z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M225.5,61.8c1.1-0.2,1.9-1.1,2.1-2.1c0,0,0.1,0,0.1,0c0.2,1.1,1.1,1.9,2.1,2.1c0,0,0,0.1,0,0.1 c-1.1,0.2-1.9,1.1-2.1,2.1c0,0-0.1,0-0.1,0C227.4,62.9,226.6,62,225.5,61.8C225.5,61.9,225.5,61.8,225.5,61.8z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M188.2,28c1.5-0.2,2.7-1.4,2.9-2.9c0,0,0.1,0,0.1,0c0.2,1.5,1.4,2.7,2.9,2.9c0,0,0,0.1,0,0.1 c-1.5,0.2-2.7,1.4-2.9,2.9c0,0-0.1,0-0.1,0C191,29.5,189.7,28.3,188.2,28C188.2,28.1,188.2,28,188.2,28z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M138,149.1c0.6-0.1,1.2-0.6,1.3-1.3c0,0,0.1,0,0.1,0c0.1,0.6,0.6,1.2,1.3,1.3c0,0,0,0.1,0,0.1 c-0.6,0.1-1.2,0.6-1.3,1.3c0,0-0.1,0-0.1,0C139.1,149.8,138.6,149.2,138,149.1C138,149.1,138,149.1,138,149.1z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M110,21.2c0.6-0.1,1.2-0.6,1.3-1.3c0,0,0.1,0,0.1,0c0.1,0.6,0.6,1.2,1.3,1.3c0,0,0,0.1,0,0.1 c-0.6,0.1-1.2,0.6-1.3,1.3c0,0-0.1,0-0.1,0C111.2,21.9,110.7,21.4,110,21.2C110,21.3,110,21.2,110,21.2z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M195,43.1c0.6-0.1,1.2-0.6,1.3-1.3c0,0,0.1,0,0.1,0c0.1,0.6,0.6,1.2,1.3,1.3c0,0,0,0.1,0,0.1 c-0.6,0.1-1.2,0.6-1.3,1.3c0,0-0.1,0-0.1,0C196.1,43.8,195.6,43.3,195,43.1C194.9,43.2,194.9,43.1,195,43.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSources);
export default __webpack_public_path__ + "static/media/Sources.ee5f9965e4ce81907fbf6912709793c8.svg";
export { ForwardRef as ReactComponent };